import React, { useState } from 'react'
import dynamic from '../../assets/images/Positive Dynamic.png'
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import { getWinLossAllGameTypeByDateService } from '../../services/winloss.service';

const Roi = () => {
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0])
  const [resultData, setResultData] = useState([]);
  const [totalAbs, setTotalAbs] = useState(0)

  const dispatch = useDispatch();

  const handleSearch = () => {
    getAgentResult();
  }


  async function getAgentResult() {
    try {
      dispatch(setIsLoading(true))
      const payload = { startDate, endDate }
      let result = await getWinLossAllGameTypeByDateService(payload)
      if (Array.isArray(result.data)) {
        const values = result.data.map(d => Math.abs(Number(d.total))).filter(v => Number.isFinite(v));
        const sum = values.length ? values.reduce((acc, v) => acc + v, 0) : 0;
        setTotalAbs(sum);
        setResultData(result.data);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error?.includes('streaming buffer')
          ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
          : error?.response?.data?.message || error?.message;

      dispatch(
        setToastMessage({
          message: errorMessage,
          type: "error",
        })
      );
    } finally {
      dispatch(setIsLoading(false))
    }
  }


  return (
    <div className="h-[80vh] bg-slate-50 p-4">
      {/* Header Section */}
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-white rounded-lg shadow-sm">
          <img src={dynamic} alt="Logo" className="w-5 h-5 object-contain" />
        </div>
        <h2 className="text-xl font-bold text-slate-800 tracking-tight">
          Win/Loss Contribution <span className="text-slate-400 font-medium text-sm">(%)</span>
        </h2>
      </div>

      {/* Main Card */}
      <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">

        {/* Filter Toolbar */}
        <div className="p-4 border-b border-slate-50 bg-slate-100/30">
          <div className="flex flex-wrap items-center gap-4">
            <div className="flex items-center bg-white border border-slate-200 rounded-xl px-3 py-1 shadow-sm focus-within:ring-2 focus-within:ring-blue-500 transition-all">
              <input
                type="date"
                value={startDate}
                className="bg-transparent outline-none text-slate-600 text-sm p-1"
                onChange={(e) => setStartDate(e.target.value)}
              />
              <span className="mx-2 text-slate-300">→</span>
              <input
                type="date"
                value={endDate}
                className="bg-transparent outline-none text-slate-600 text-sm p-1"
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>

            <button
              onClick={handleSearch}
              className="bg-slate-900 hover:bg-slate-800 text-white px-6 py-2 rounded-xl text-sm font-medium transition-all active:scale-95 flex items-center gap-2"
            >
              Apply Filters
            </button>
          </div>
        </div>

        {/* Data List */}
        <div className="px-6 py-4 space-y-4 h-[75vh] overflow-y-auto">
          {Array.isArray(resultData) && resultData.map((item, index) => {
            const totalNum = Number(item.total) || 0;
            const magnitude = Math.abs(totalNum);
            const percentage = totalAbs ? Math.trunc((magnitude / totalAbs) * 100) : 0;
            const isGain = totalNum <= 0;

            return (
              <div key={index} className="group">
                <div className="flex justify-between items-center mb-2">
                  <div>
                    <div className="flex items-center gap-4">
                      <span className="text-sm font-semibold text-slate-700">
                        {item.gameType}
                      </span>
                      <span className="text-xs font-medium px-2 py-0.5 rounded-md bg-slate-100 text-slate-500">
                        {magnitude.toLocaleString()}
                      </span>
                    </div>
                  </div>

                  <div className={`text-right ${isGain ? 'text-emerald-600' : 'text-rose-600'}`}>
                    <span className="text-lg font-bold">{percentage}%</span>
                    <span className="text-[10px] block uppercase font-bold opacity-70">
                      {isGain ? 'Profit' : 'Loss'}
                    </span>
                  </div>
                </div>

                {/* Progress Bar Container */}
                <div className="relative w-full h-3 bg-slate-100 rounded-full overflow-hidden">
                  <div
                    className={`absolute left-0 top-0 h-full  transition-all duration-1000 ease-out ${isGain
                        ? 'bg-gradient-to-r from-emerald-400 to-emerald-500 shadow-[0_0_10px_rgba(16,185,129,0.3)]'
                        : 'bg-gradient-to-r from-rose-400 to-rose-500 shadow-[0_0_10px_rgba(244,63,94,0.3)]'
                      }`}
                    style={{ width: `${percentage}%` }}
                  />
                </div>
              </div>
            );
          })}

          {(!resultData || resultData.length === 0) && (
            <div className="py-20 text-center">
              <p className="text-slate-400">No data found for the selected range.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Roi